import { createGetContractBasedDataFetchSlice } from '@cp-shared-19/frontend-integration';
import { PartialEarlySettlement, EarlySettlementError } from 'cpes-common';
import { CpDataApi } from 'cp-xhr';

const { reducer, fetchData } = createGetContractBasedDataFetchSlice<PartialEarlySettlement[], EarlySettlementError>({
    dataName: 'partialEarlySettlement',
    fetchCallback(link: string) {
        return CpDataApi.get(link).then(response => response.data);
    },
});

export default reducer;
export const fetchPartialEarlySettlement = fetchData;
